export default "__VITE_ASSET__CJ4XF8uB__"